// extracted by mini-css-extract-plugin
export default {"socialLinksContainer":"nRwicPKBCTl7g54MfUe4","blackBoxStyle":"dRjStjZQKndAmxpClKof","socialLink":"o9EcskesWqM1lprrLKm_","borderLinkWrapper":"F9bxDwsSEt2p8yZjoPI7"};